<template>
    <div>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            <router-link :to="{name:'configuracion-carta'}">  {{$t('configuracionCarta')}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            Diagnóstico
                        </li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="listBusiness"><strong>{{$t("negocio")}}</strong></label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           @change="permisoCarta()"
                                           :placeholder="this.$i18n.t('seleccionaNegocio')">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <button class="btn btn-primary" style="margin-top:2.75%" @click="diagnosisProducts()">
                                <i class="fas fa-burger"></i> Productos
                            </button>
                            <button class="btn btn-primary" style="margin-top:2.75%" @click="diagnosisSubproducts()">
                                <i class="fas fa-bacon"></i> Materias primas
                            </button>

                        </div>
                    </div>
                </div>
            </div>

            <template v-if="permiso===1">

            </template>
            <template v-else-if="permiso && respuesta">

                <div class="col-md-12">
                    <div class="card">
                        <div class="row">
                            <div class="col-md-12" v-if="subproductosErroneos == -1">
                                <!-- AQUI la tabla -->   
                                <div v-if="productosErroneos.length > 0">
                                    <!--<div class="alert alert-danger" role="alert">
                                        <i class="fas fa-exclamation-triangle" style="margin-right:0.5%"></i> <strong>{{ $t("hayProductosSinRelacion") }}</strong>
                                    </div>-->
                                    <div class="alert alert-danger" role="alert">
                                        <span><strong>Hay productos que no están relacionados con el TPV</strong></span>
                                    </div>
                                    <div class="table-responsive">
                                        <table class="table table-bordered table-striped">
                                            <thead class="thead-dark">
                                            <tr>
                                                <th class="col-4">
                                                    Nombre
                                                <!--<span
                                                    v-if="ordenarNombre"
                                                    @click="sortedArrayASC(1), (ordenarNombre = 0)"
                                                    ><i style="color: white" class="fa fa-angle-up"></i>
                                                    {{ $t("nombre") }}
                                                </span>
                                                <span
                                                    v-else
                                                    @click="sortedArrayDESC(1), (ordenarNombre = 1)"
                                                    ><i style="color: white" class="fa fa-angle-down"></i>
                                                    {{ $t("nombre") }}
                                                </span>-->
                                                </th>
                                                <th class="col-3">
                                                    {{$t("categoria")}}
                                                </th>
                                                <th class="col-1">
                                                    {{$t("precio")}}
                                                </th>
                                                <th class="col-1">
                                                    {{$t("baja")}}
                                                </th>
                                                <th class="col-2">
                                                    {{$t("productoRelacionadoConTpv")}}
                                                </th>
                                                <th>{{ $t("acciones") }}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(pro, index) in productosErroneos">
                                                <td class="col-4">
                                                    {{ pro.nameProducto }}
                                                </td>
                                                <td>
                                                    {{pro.catProd}}
                                                </td>
                                                <td>
                                                    {{pro.precio | currency}}
                                                </td>
                                                <td>
                                                    <span v-if="pro.baja == 0">
                                                        NO
                                                    </span>
                                                    <span v-else>
                                                        SI
                                                    </span>
                                                </td>
                                                <td>
                                                    <span v-if="pro.idProductoTPV==null">
                                                        No tiene relación
                                                    </span>
                                                    <span v-else>
                                                        {{pro.idProductoTPV}}
                                                    </span>
                                                </td>
                                                <td>
                                                    <router-link
                                                            :to="{
                                                                name: 'producto-carta',
                                                                params: {
                                                                    idBusiness: idBusiness,
                                                                    idCarta: idCarta,
                                                                    idProducto: pro.id,
                                                                },
                                                            }"
                                                        >
                                                        <i class="fas fa-pen" style="margin-left:10%; color:orange"></i>
                                                    </router-link>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div v-else-if="productosErroneos.length <= 0 " class="alert alert-success" role="alert">
                                  <i class="fas fa-check-circle" style="margin-right:0.5%"></i> <strong>{{ $t("productosSinRelacionEnElTpv") }}</strong>
                                    {{ $t("enEsteNegocio") }}
                                </div>

                                <div v-else-if="productosErroneos==-1" class="alert alert-primary" role="alert">
                                    <strong>{{ $t("pulseElBoton") }}</strong>
                                    {{ $t("paraRealizarDiagnosis") }}
                                </div>

                            </div>
                            <div class="col-md-12" v-else>
                                <!-- AQUI la tabla -->   
                                <div v-if="subproductosErroneos.length > 0">
                                    <!--<div class="alert alert-danger" role="alert">
                                        <i class="fas fa-exclamation-triangle" style="margin-right:0.5%"></i> <strong>{{ $t("hayProductosSinRelacion") }}</strong>
                                    </div>-->
                                    <div class="alert alert-danger" role="alert">
                                        <span><strong>Hay materias primas que no están relacionadas con el TPV</strong></span>
                                    </div>
                                    <div class="table-responsive">
                                        <table class="table table-bordered table-striped">
                                            <thead class="thead-dark">
                                            <tr>
                                                <th class="col-4">
                                                <!--<span
                                                    v-if="ordenarNombreS"
                                                    @click="sortedArraySASC(1), (ordenarNombreS = 0)"
                                                    ><i style="color: white" class="fa fa-angle-up"></i>
                                                    {{ $t("nombre") }}
                                                </span>
                                                <span
                                                    v-else
                                                    @click="sortedArraySDESC(1), (ordenarNombreS = 1)"
                                                    ><i style="color: white" class="fa fa-angle-down"></i>
                                                    {{ $t("nombre") }}
                                                </span>-->
                                                Nombre
                                                </th>
                                                <th class="col-3">
                                                    Variación precio
                                                </th>
                                                <th class="col-1">
                                                    Disponible
                                                </th>
                                                <th class="col-1">
                                                    {{$t("baja")}}
                                                </th>
                                                <th class="col-2">
                                                    {{$t("productoRelacionadoConTpv")}}
                                                </th>
                                                <th>{{ $t("acciones") }}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(s, index) in subproductosErroneos">
                                                <td class="col-4">
                                                    {{ s.name }}
                                                </td>
                                                <td>
                                                    {{s.variacion_precio | currency}}
                                                </td>
                                                <td>
                                                    <span v-if="s.noDisponible == 0">
                                                        SI
                                                    </span>
                                                    <span v-else>
                                                        NO
                                                    </span>
                                                </td>
                                                <td>
                                                    <span v-if="s.baja == 0">
                                                        NO
                                                    </span>
                                                    <span v-else>
                                                        SI
                                                    </span>
                                                </td>
                                                <td>
                                                    <span v-if="s.idSubroductoTPV==null">
                                                        No tiene relación
                                                    </span>
                                                    <span v-else>
                                                        {{s.idSubroductoTPV}}
                                                    </span>
                                                </td>
                                                <td>
                                                    <router-link
                                                        :to="{ name: 'materia-prima-carta', params: { idBusiness: idBusiness, idMateriaPrima: s.id } }">
                                                        <i style="color: orange" v-tooltip.top-center="$i18n.t('editar')"
                                                            class="fas fa-pencil-alt"></i>
                                                    </router-link>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div v-else-if="subproductosErroneos.length <= 0 " class="alert alert-success" role="alert">
                                  <i class="fas fa-check-circle" style="margin-right:0.5%"></i> <strong>{{ $t("productosSinRelacionEnElTpv") }}</strong>
                                    {{ $t("enEsteNegocio") }}
                                </div>

                                <div v-else-if="subproductosErroneos==-1" class="alert alert-primary" role="alert">
                                    <strong>{{ $t("pulseElBoton") }}</strong>
                                    {{ $t("paraRealizarDiagnosis") }}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>


            </template>
            <template v-if="!permiso">

                <div class="col-md-12">
                    <div class=" alert alert-primary" align="center">
                        <h3><i class="fas fa-exclamation-circle"></i> {{$t('esteNegocioNoTieneAccesoAEsteModulo')}}.</h3>

                        <span> {{$t('paraMasInformacionContacteConSu')}} <strong>{{($t('distribuidor'))}}</strong>.</span>

                    </div>
                </div>

            </template>

        </div>

    </div>

</template>

<script>

    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button, Switch, Checkbox} from 'element-ui'
    import {Loading} from 'element-ui';
    import swal from 'sweetalert2'
    import moment from 'moment'
    export default {
        name: "ConfiguracionNegocio",
        data() {
            return {
                listOperarios: [],
                listAgencias: [],
                listBusinesses: [],
                idBusiness: 0,
                permiso: 1,
                respuesta:false,
                productosErroneos: -1,
                subproductosErroneos: -1,
                idCarta: 0,
                ordenarNombre: 0,
                ordenarNombreS: 0
            
            }
        },
        created() {

            this.loading = Loading.service({ text: "Cargando..." });

            this.getBusiness();

            this.$store.dispatch('setNameRoute', 'Configuración negocio');
           
            // this.getConfigTpv();

            
        },
        methods: {
            permisoCarta() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt,
                        estado: this.estado
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'delivery/getPermisoCarta', config)
                    .then(function (response) {
                        if (response.data.response) {
                            if (response.data.result) {
                                vm.respuesta=true;
                                vm.permiso = response.data.result.permiso;
                                // if(response.data.result.permiso) {
                                //     vm.getConfigTpv();
                                // }
                            }else{
                                vm.respuesta=false;

                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                        
                        vm.loading.close();
                    });
            },
            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {

                        if (vm.$store.getters.idBusiness) {
                            vm.idBusiness = vm.$store.getters.idBusiness;
                        }
                        else {
                            vm.idBusiness = response.data.result[0].id;
                        }
                        vm.listBusinesses = response.data.result;
                        
                        vm.permisoCarta();

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            getConfigTpv() {
                var config = {
                    params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                    numConfig: 61,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios
                    .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
                    .then(function(response) {
                        if (response.data.response) {
                            vm.configuracionCarta.emailCliente = true;
                        } else {
                            vm.configuracionCarta.emailCliente = false;
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
                },

            diagnosisProducts(){
                this.loading = Loading.service({ text: "Cargando..." });
                var config = {
                    params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.axios
                    .get(this.$store.getters.apiUrl + "delivery/diagnosticoProductos", config)
                    .then(function(response) {
                        if (response.data.response) {
                            vm.productosErroneos = response.data.result;
                            vm.subproductosErroneos = -1;
                            // vm.productosErroneos = []
                            vm.getIdCarta();
                        } 
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            },
            diagnosisSubproducts(){

                this.loading = Loading.service({ text: "Cargando..." });

                var config = {
                    params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.axios
                    .get(this.$store.getters.apiUrl + "delivery/diagnosticoSubproductos", config)
                    .then(function(response) {
                        if (response.data.response) {

                            vm.subproductosErroneos = response.data.result;
                            vm.productosErroneos = -1;
                            // vm.productosErroneos = []
                            vm.getIdCarta();
                        } 
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            },
            getIdCarta(){
                
                var config = {
                    params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.axios
                    .get(this.$store.getters.apiUrl + "general/getIdBusinessInfo", config)
                    .then(function(response) {
                        if (response.data.response) {
                            console.log(response.data.result);
                            vm.idCarta = response.data.result;
                        } else {
                            vm.idCarta = 0
                        }

                        vm.loading.close();
                    })
                    .catch(function(error) {
                        console.log(error);
                    });

            }
           
        
        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            [Switch.name]: Switch,
            [Checkbox.name]: Checkbox
        },
    }
</script>
<style>
  
</style>
<style scoped>

    tbody tr:hover {
        background-color: rgba(0, 153, 130, 0.2);
        cursor: pointer;
    }

    td div {
        padding: 12px 8px;
        color: #333;
    }

    .buttonsSearch:hover {
        cursor: pointer;
        background-color: rgba(0, 153, 130, 0.1);
    }

    .card {
        padding: 20px;
    }

    .input-group button {
        height: 40px;
    }

    .botonTotal {
        border: 1px solid #28a745;
        color: #FFFFFF;
        background-color: #28a745;
        font-weight: 400;
        padding: 8px 16px;
        /* cursor: pointer; */
        margin-bottom: 5px;
        font-size: 14px;
        line-height: 1.42857143;
    }

    .nombreProducto {
        color: #fff;
        background-color: #0e0e0e;
        text-shadow: 1px 1px #333;
        font-weight: 700;
        font-size: 15px;
    }

    .tituloPedido {

        color: #1E22AA;
        font-family: "Numier", "Helvetica Neue", Arial;
    }

</style> 


// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Configuracion/Diagnostico/DiagnosticoCarta.vue